import { PremiumFeature } from 'gleblu-socket-api';
import { Action, createAction } from 'redux-act';

import { Subscription } from '../../../models/interfaces/Subscriptions';
import TimestampPayload from '../TimestampPayload';

export interface ChangeSubscriptionPricing extends TimestampPayload {
  id: string;
  placeUuid: string;
  feature: PremiumFeature;
  priceId: string;
}
export const changeSubscriptionPricing = createAction<ChangeSubscriptionPricing>('CHANGE_SUBSCRIPTION_PRICING');
export type ChangeSubscriptionPricingActionType = Action<ChangeSubscriptionPricing>;

export interface SubscriptionPricingChangedPayload extends TimestampPayload {
  subscription: Subscription;
  placeUuid: string;
  feature: PremiumFeature;
}
export const subscriptionPricingChanged = createAction<SubscriptionPricingChangedPayload>('SUBSCRIPTION_PRICING_CHANGED');

export interface SubscriptionPricingChangeFailedPayload extends TimestampPayload {
  id: string;
}
export const subscriptionPricingChangeFailed = createAction<SubscriptionPricingChangeFailedPayload>('SUBSCRIPTION_PRICING_CHANGE_FAILED');
